import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.button`
  width: 35px;
  padding: 0px 0px 0px 0px !important;
  margin: 0px 0px 0px 0px !important;
  position: absolute;
  left: 32px;
  display: none;
  justify-content: center;
  align-items: center;
  align-content: center;
  background: transparent;
  border: none;
  z-index: 110 !important;
  cursor: pointer;

  // Botón Abrir
  button {
    height: 34px;
    background-color: transparent;
    border: 0;
    color: #A5ADBB;
    font-size: 28px;
    cursor: pointer;
    transition: 0.2s all;
  }

  // Botón Abrir Hover
  button:hover {
    color: var(--negro);
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    display: flex;
  }
`;

export default Container;
